/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { AdditionalServiceVo } from './AdditionalServiceVo';
import {
    AdditionalServiceVoFromJSON,
    AdditionalServiceVoFromJSONTyped,
    AdditionalServiceVoToJSON,
    AdditionalServiceVoToJSONTyped,
} from './AdditionalServiceVo';

/**
 * 
 * @export
 * @interface ResponseListAdditionalServiceVo
 */
export interface ResponseListAdditionalServiceVo {
    /**
     * 接口状态码
     * @type {number}
     * @memberof ResponseListAdditionalServiceVo
     */
    code?: number;
    /**
     * 接口返回消息
     * @type {string}
     * @memberof ResponseListAdditionalServiceVo
     */
    message?: string;
    /**
     * 
     * @type {Array<AdditionalServiceVo>}
     * @memberof ResponseListAdditionalServiceVo
     */
    data?: Array<AdditionalServiceVo>;
}

/**
 * Check if a given object implements the ResponseListAdditionalServiceVo interface.
 */
export function instanceOfResponseListAdditionalServiceVo(value: object): value is ResponseListAdditionalServiceVo {
    return true;
}

export function ResponseListAdditionalServiceVoFromJSON(json: any): ResponseListAdditionalServiceVo {
    return ResponseListAdditionalServiceVoFromJSONTyped(json, false);
}

export function ResponseListAdditionalServiceVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResponseListAdditionalServiceVo {
    if (json == null) {
        return json;
    }
    return {
        
        'code': json['code'] == null ? undefined : json['code'],
        'message': json['message'] == null ? undefined : json['message'],
        'data': json['data'] == null ? undefined : ((json['data'] as Array<any>).map(AdditionalServiceVoFromJSON)),
    };
}

export function ResponseListAdditionalServiceVoToJSON(json: any): ResponseListAdditionalServiceVo {
    return ResponseListAdditionalServiceVoToJSONTyped(json, false);
}

export function ResponseListAdditionalServiceVoToJSONTyped(value?: ResponseListAdditionalServiceVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'code': value['code'],
        'message': value['message'],
        'data': value['data'] == null ? undefined : ((value['data'] as Array<any>).map(AdditionalServiceVoToJSON)),
    };
}

